import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FaRegEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logoSGR from '../../assets/SGRLock.png';
import logoSwint from '../../assets/swintLogo.svg';
import Button from '../../components/Button';
import Input from '../../components/Input';
import Loading from '../../components/Loading';

import LanguageSwitch from '../../components/LanguageSwitch';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import api from '../../services/api';
import { Container, Content } from './styles';

const ForgotPassword: React.FC = () => {
  const { register, handleSubmit, setValue } = useForm();
  const [errorMessage, setErrorMessage] = useState('');
  const [email, setEmail] = useState('');
  const [send, setSend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.pages.forgotPassword);
  const { tp: tpLogos } = translationPage(tr => tr.components.logos);

  const onSubmit = async () => {
    setIsLoading(true);
    const response = await api.post('/forgot-password', {
      user: email,
    });
    if (response.data.result === 'error') {
      setErrorMessage(response.data.message);
      setLoading(false);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      setSend(true);
    }
    setIsLoading(false);

    return { error: false, message: 'success' };
  };

  useEffect(() => {
    setValue('email', email);
  }, [setValue, email]);

  return (
    <Container>
      <LanguageSwitch />
      <img src={logoSGR} alt={tpLogos('sgrLoc')} />
      <Content>
        <img src={logoSwint} alt={tpLogos('swint')} />
        <h1>{tp('title')}</h1>
        {!send ? (
          <>
            {errorMessage && <p>{errorMessage}</p>}
            <form onSubmit={handleSubmit(onSubmit) as any}>
              <Input
                {...register('email')}
                type="text"
                placeholder={tp('form.emailPlaceholder')}
                label={tp('form.emailLabel')}
                onChange={e => setEmail(e.target.value)}
              />
              <Button
                type="submit"
                title={tp('form.submit')}
                icon={FaRegEnvelope}
                isLoading={isLoading}
                disabled={isLoading}
              />
            </form>
          </>
        ) : (
          <h3>{tp('successMessage')}</h3>
        )}
        <Link to="/">{tp('backToLogin')}</Link>
      </Content>
      {loading && <Loading />}
    </Container>
  );
};

export default ForgotPassword;
